module.exports = __webpack_public_path__ + "assets/6210d5dc28d9a4ba100fdbcf2a4edbe3.png";